import React, { useRef } from 'react';
import { Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import SelectInput from '@/components/General/inputs/SelectInput';
import FormPaymentCheckout from '../FormPaymentCheckout';
import { formatPaymentAmount } from '@/data/formPayments';

export default function PaymentField({ field, value, onChange, disabled, paymentContext }) {
    const valueRef = useRef(value);
    valueRef.current = value;
    const cfg = field.config || {};
    const amountOptions = Array.isArray(cfg.amountOptions) ? cfg.amountOptions.filter((o) => o && o.label && Number.isInteger(o.amountCents)) : [];
    const hasOptions = amountOptions.length > 0;
    const selectedOption = hasOptions ? amountOptions.find((o) => o.id === value?.optionId) || null : null;
    const channelOptions = [
        ...(['inPerson', 'both'].includes(cfg.allowedChannels) ? [{ label: 'In Person Cash/Check', value: 'inPerson' }] : []),
        ...(['electronic', 'both'].includes(cfg.allowedChannels) ? [{ label: 'Electronic — Card or ACH', value: 'electronic' }] : []),
        ...(!field.required ? [{ label: 'No payment', value: 'skip' }] : []),
    ];
    const amountText = hasOptions
        ? (selectedOption ? formatPaymentAmount(selectedOption.amountCents) : 'Select an amount')
        : formatPaymentAmount(cfg.amountCents);
    const snapshot = hasOptions && selectedOption ? { ...cfg, amountCents: selectedOption.amountCents } : cfg;
    return (
        <View style={styles.container} testID={`payment-field-${field.fieldId}`}>
            <Text style={styles.price}>{field.label || 'Payment'}{field.required ? ' *' : ''} · {amountText}{!hasOptions && cfg.optionLabel ? ` — ${cfg.optionLabel}` : ''}</Text>
            {!!field.description && <Text style={styles.description}>{field.description}</Text>}
            {hasOptions && (
                <View testID={`form-field-${field.fieldId}-amount`}>
                    <SelectInput
                        title="Amount"
                        placeholder="Select an option"
                        options={amountOptions.map((o) => ({ label: `${o.label} — ${formatPaymentAmount(o.amountCents)}`, value: o.id }))}
                        value={value?.optionId || null}
                        onUpdate={(optionId) => onChange?.({ ...value, optionId })}
                        required={field.required}
                        hideClearButton
                        disabled={disabled}
                    />
                </View>
            )}
            {(!hasOptions || selectedOption || !field.required) && (
                <>
                    <SelectInput title="Payment option" value={value?.channel || null} onUpdate={(channel) => onChange?.({ ...value, channel })} options={channelOptions} disabled={disabled} required={field.required} hideClearButton />
                    {hasOptions && !selectedOption && value?.channel && value.channel !== 'skip' && <Text style={styles.description}>Select an amount above to continue.</Text>}
                    {!disabled && value?.channel === 'electronic' && (!hasOptions || selectedOption) && <FormPaymentCheckout prepare context={paymentContext} snapshot={snapshot} initialSelection={value} onChange={(selection) => onChange?.({ ...valueRef.current, channel: 'electronic', ...selection })} />}
                    {value?.channel === 'inPerson' && <Text style={styles.description}>Submit now; payment remains unpaid until an entry manager records receipt.</Text>}
                </>
            )}
        </View>
    );
}

const styles = StyleSheet.create(({ colors, fonts, spacing, typography }) => ({
    container: { gap: spacing.sm },
    price: { color: colors.forms, fontFamily: fonts.heading, fontSize: typography.body },
    description: { color: colors.textSecondary, fontFamily: fonts.body, fontSize: typography.caption },
}));
